import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default function initReviewsSwiper() {
  const swiper = new Swiper(".reviews__slider", {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    allowTouchMove: false,
    autoHeight: true,

    navigation: {
      nextEl: ".reviews-button-next",
      prevEl: ".reviews-button-prev",
    },

    // 👇 Настройки под разные разрешения
    breakpoints: {
      640: {
        slidesPerView: 2,
        autoHeight: false,
      },
      1024: {
        slidesPerView: 2.6,
        autoHeight: false,
      },
      1440: {
        slidesPerView: 3.3,
        autoHeight: false,
      },
    },
  });

  return swiper;
}
